import { filterTypographyProps, getTypographyStyles } from './utils';
import { type ForwardedRef, forwardRef } from 'react';
import { mergeProps } from 'react-aria';

import { type HtmlPropsWithoutClassNameAndStyle, type TypographyProps } from './types';
import { TextContent } from './TextContent';

export type Props = HtmlPropsWithoutClassNameAndStyle<'p', TypographyProps>;

export const Paragraph = forwardRef(function _Paragraph(props: Props, ref: ForwardedRef<HTMLHeadingElement>) {
  const { typographyProps, restProps } = filterTypographyProps(props);
  const { truncate, ...restTypographyProps } = typographyProps;
  const { children, ...rest } = restProps;
  const styles = getTypographyStyles(restTypographyProps);

  return (
    <p {...mergeProps(rest, { className: styles })} ref={ref}>
      <TextContent truncate={truncate}>{children}</TextContent>
    </p>
  );
});
